import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import fr from "./fr";
import en from "./en";
import it from "./it";
import ar from "./ar";

export const LANGS = [
  { code: "fr", native: "Français" },
  { code: "en", native: "English" },
  { code: "it", native: "Italiano" },
  { code: "ar", native: "العربية" },
];

const RTL = ["ar"];

const applyDir = (lng) => {
  document.documentElement.lang = lng;
  document.documentElement.dir = RTL.includes(lng) ? "rtl" : "ltr";
};

const stored = localStorage.getItem("bkoss-lang");
const initial = LANGS.some((l) => l.code === stored) ? stored : "fr";

i18n.use(initReactI18next).init({
  resources: {
    fr: { translation: fr },
    en: { translation: en },
    it: { translation: it },
    ar: { translation: ar },
  },
  lng: initial,
  fallbackLng: "fr",
  interpolation: { escapeValue: false },
});

applyDir(initial);
i18n.on("languageChanged", (lng) => {
  localStorage.setItem("bkoss-lang", lng);
  applyDir(lng);
});

export default i18n;
